export default __webpack_public_path__ + "static/media/digital-empire-small-6@2x.1ca6d15c.png";